import { buildCommonFilters, embedFilter, labeledMapItem, numericMapItem } from '../sharedFilters'
import { OPEN_TIME_RANGE_FROM } from '../../utils/timeUtils'

const DATASET_KEY = 'units'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: {},                              // units.description
  REGION: {},                                    // regions.name
  MUNICIPALITY: {},                              // municipalities.name
  SECTOR: {},                                    // sectors.name
  CENTER: {},                                    // centers.name
  TENANT: {},                                    // tenants.name
  STATUS: false,                                 // the `status` param is routers.active, not the unit's
  USER: false,                                   // no users join
})

const ACTIVE_LABELS = { 0: 'Inactiva', 1: 'Activa' }
const ACTIVE_MAPPING = JSON.stringify({
  'units.active': ACTIVE_LABELS,
  active: ACTIVE_LABELS,
})
const IN_PROJECT_LABELS = { 0: 'No', 1: 'Sí' }
const IN_PROJECT_MAPPING = JSON.stringify({
  'units.in_project': IN_PROJECT_LABELS,
  in_project: IN_PROJECT_LABELS,
})

export default {
  key: DATASET_KEY,
  label: 'Instalaciones',
  // The dataset $time_filter rides units.updated_at (measured on staging:
  // from=2026-08-10 leaves 9 of the 247 units and trims only that column,
  // while cameras_proxy.updated_at still reaches back to 2023). It tracks the
  // last edit of the record, not when the installation exists, so the 30-day
  // default would hide the catalog: this dataset opens the range instead.
  timeColumn: 'units.updated_at',
  defaultTimeRange: { from: OPEN_TIME_RANGE_FROM },
  permission: { action: 'read', subject: 'Units' },

  tables: {
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "in_project", "created_at", "updated_at"],
    units_cameras: ["id", "id_unit", "id_camera"],
    cameras_proxy: ["id", "created_at", "updated_at"],
    view_camera_name: ["id_cameras_proxy", "camera_name"],
    routers: ["id", "id_tenant", "active"],
    regions: ["id", "name"],
    municipalities: ["id", "name"],
    sectors: ["id", "id_center", "name"],
    centers: ["id", "name"],
    tenants: ["id", "name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'regions.name',
  },

  csvConfig: {
    columns: 'units.description,units.active,units.in_project,units.rems,units.sirh,units.address_1,units.postal_code,units.created_at,units.updated_at,view_camera_name.camera_name,regions.name,municipalities.name,sectors.name,centers.name,tenants.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'regions.name', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'tenants.name', label: 'Tenant' },
    { key: 'units.active', label: 'Estatus', defaultParams: { mapping: ACTIVE_MAPPING } },
    { key: 'units.in_project', label: 'En proyecto', defaultParams: { mapping: IN_PROJECT_MAPPING } },
    { key: 'units.created_at', label: 'Fecha de alta', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'units.active', 'Estatus', 'active', {
      optionsOverrides: { mapItem: labeledMapItem(ACTIVE_LABELS) },
    }),
    embedFilter(DATASET_KEY, 'units.in_project', 'En proyecto', 'in_project', {
      optionsOverrides: { mapItem: labeledMapItem(IN_PROJECT_LABELS) },
    }),
    embedFilter(DATASET_KEY, 'units.rems', 'REMS', 'rems', {
      optionsOverrides: { mapItem: numericMapItem },
    }),
    embedFilter(DATASET_KEY, 'units.sirh', 'SIRH', 'sirh', {
      optionsOverrides: { mapItem: numericMapItem },
    }),
    embedFilter(DATASET_KEY, 'view_camera_name.camera_name', 'Cámara', 'camera'),
    {
      key: 'units_created_at',
      label: 'Fecha de alta',
      filterType: 'where-date',
      whereColumn: 'units.created_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'units.updated_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
